import React, { memo, useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import InputTextAreaAutosize from 'src/components/common/field/InputTextAreaAutosize';
import { getToken } from 'src/utils/auth';
import { postAPI } from 'src/utils/api';
import { DataNoteType } from 'src/components/calendar/TypeCustom';

interface DialogDetailProps {
  data: DataNoteType;
  onClose: (isRefreshList?: boolean) => void;
  onSave?: (dataNote: DataNoteType, value: string) => void;
};

const DialogEditNote: React.FC<DialogDetailProps> = (props) => {
  const [value, setValue] = useState<string>('');

  const handleSave = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      const data = {
        doctorid: props.data.doctorid,
        note: value,
        reservetype: props.data.reservetype,
        thedate: props.data.thedate,
        ts: props.data.ts,
        typeid: props.data.typeid
      };

      postAPI(`/reserve/save-note?&token=${token}`, data)
        .then((res: any) => {
          if (res.code === 200) {
            props.onClose(true);

            let dataNew = {
              ...props.data,
              ts: res.data.ts ? res.data.ts : props.data.ts
            };

            props.onSave?.(dataNew, value);
          }
        })
        .finally(() => {
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleChange = (value: string) => {
    setValue(value);
  }

  useEffect(() => {
    if (props.data.typeid !== 0) {
      setValue(props.data.note)
    }
    // eslint-disable-next-line
  }, [props.data.open]);

  return (
    <Dialog
      open={props.data.open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '398px',
          height: '258px',
          m: '0px'
        }
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '24px', pb: '0px' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}>
            メモ
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 24px 24px 24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          overflow: 'hidden'
        }}
      >
        <SimpleBar
          style={{ height: 'calc(100vh - 210px)', borderWidth: '18px' }}
        >
          <Stack>
            <InputTextAreaAutosize value={value} onChange={handleChange} resize='none' width='100%' height='118px' />
          </Stack>
        </SimpleBar>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px 24px '
        }}
      >
        <BtnOutlineGradient text='キャンセル' handleButtonClick={handleClose} />
        <BtnGradient text='登録' handleButtonClick={handleSave} />
      </DialogActions>
    </Dialog>
  );
};

export default memo(DialogEditNote);
